/**
 * Generic helper to check if a React element matches a specific displayName.
 * Handles regular components and React.memo wrapped components.
 *
 * @param child - React element to check
 * @param displayName - Expected displayName to match against
 * @returns true if the element's displayName matches
 *
 * @example
 * ```tsx
 * if (isElement(child, 'XAxis')) {
 *   // Handle XAxis component
 * }
 * ```
 */
export function isElement(child: React.ReactElement, displayName: string): boolean {
  const type = child.type as { displayName?: string; type?: { displayName?: string } };

  // Direct match
  if (type.displayName === displayName) {
    return true;
  }

  // For React.memo, check the wrapped component's displayName
  if (type.type?.displayName === displayName) {
    return true;
  }

  return false;
}
